import React from "react";
import {graphql} from "gatsby";
import PropTypes from "prop-types";
import AnchoredPageComponent from "../components/AnchoredPageComponent";
import Layout from "../components/Layout";
import Helmet from "react-helmet";
import MetaStatic from "../components/metafields/MetaStatic";
import HelmetScripts from "../components/metafields/helmetScripts";

class AnchoredPage extends React.Component {
    render() {
        const {data} = this.props;
        const {
            data: {footerData, navbarData},
        } = this.props;
        const {frontmatter: anchoredData} = data.markdownRemark;
        const {frontmatter: metafields} = data.metaData.edges[0].node;
        const newsroom = data.releaseNotesData.edges;

        return (
            <Layout footerData={footerData} navbarData={navbarData} siteMetadata={data.site.siteMetadata}>
                <MetaStatic
                    metadata={metafields.generalMetaData}
                />
                <MetaStatic
                    metadata={anchoredData.anchoredPage.pageMetaData}
                />
                <Helmet>

                {metafields.googleAnalyticsTracker && metafields.googleAnalyticsTracker !== '' && (
                    <script type="text/javascript">{metafields.googleAnalyticsTracker}</script>
                )}

                    <link rel="icon" type="image/png" href={data.site.siteMetadata.favicon}/>
                </Helmet>

                <HelmetScripts
                    scripts={anchoredData.anchoredPage.pageSchemaScripts}
                />
                <HelmetScripts
                    scripts={metafields.generalSchemaScripts}
                />

                <AnchoredPageComponent nosqlData={anchoredData} pageTitle={anchoredData.title} newsroomData={newsroom}/>

            </Layout>
        );
    }
}

AnchoredPage.propTypes = {
    data: PropTypes.shape({
        allMarkdownRemark: PropTypes.shape({
            edges: PropTypes.array,
        }),
    }),
};

export default AnchoredPage;

export const pageQuery = graphql`
    query anchoredPageQuery($slug: String!) {
        markdownRemark(fields: { slug: { eq: $slug } } ) {
            frontmatter {
                title
                metaTitle
                metaDescription
                columns
                anchoredPage {
                    metaTitle
                    metaDescription
                    pageMetaData
                    pageSchemaScripts {
                        type
                        script
                    }
                    iconList {
                        caption
                        image
                        slug
                        linkType
                        soon
                    }
                    textList {
                        slug
                        heading
                        subheading
                        title
                        text
                        additionalTexts {
                            title
                            text
                            image
                            imageAlt
                            imageTitle
                        }
                        image
                        imageAlt
                        imageTitle
                        showShadow
                        setSmallImage
                        imageWidth
                        imageHeight
                        url
                        urlName
                        linkType
                        itemList {
                            title
                            text
                            additionalTexts {
                                title
                                text
                                image
                                imageAlt
                                imageTitle
                                showShadow
                                imageWidth
                                imageHeight
                            }
                            image
                            imageAlt
                            imageTitle
                            showShadow
                            imageWidth
                            imageHeight
                            setSmallImage
                            url
                            urlName
                            linkType
                        }
                    }
                }
            }
        }
        newsroomData: allMarkdownRemark(
            filter: { frontmatter: { templateKey: { eq: "newsroom" } } }
            sort: {fields: frontmatter___date, order: DESC}
            limit: 1000
        ) {
            edges {
                node {
                    fields {
                        slug
                    }
                    frontmatter {
                        templateKey
                        title
                        text
                        excerpt
                        date: date(formatString: "MMMM D, YYYY")
                        author
                        image
                        imageAlt
                        isExternalImage
                        externalImageUrl
                        readMoreLabel
                        linkType
                        urlName
                    }
                }
            }
        }
        releaseNotesData: allMarkdownRemark(
            filter: {frontmatter: {templateKey: {eq: "releaseNotes"}}},
            sort: {fields: frontmatter___date, order: DESC},
            limit: 1000
        ) {
            edges {
                node {
                    fields {
                        slug
                    }
                    frontmatter {
                        templateKey
                        title
                        text
                        excerpt
                        date: date(formatString: "MMMM D, YYYY")
                        author
                        image
                        imageAlt
                        isExternalImage
                        externalImageUrl
                        readMoreLabel
                        linkType
                        urlName
                    }
                }
            }
        }
        ...LayoutFragment
        site {
            siteMetadata {
                templateKey
                title
                description
                favicon
                screen
                googleAnalyticsTracker
                mailchimpTracker
                logoImage {
                    url
                    imageAlt
                    image
                }
            }
        }
    }
`;
